export interface SortieDto {
    // Generated on the backend
    id?: number

    start_sortie?: string
    stop_sortie?: string
    duration?: number
    start_hobbs?: number
    stop_hobbs?: number
    active_hobbs?: number
    mob_hobbs?: number
}

export interface Sortie extends SortieDto {
    // Frontend only fields
    frontend_id: number
    fe_start_sortie: Date
    fe_stop_sortie: Date
}

export const getInitialSortie = (flownDate: Date): Sortie => ({
    frontend_id: 1,
    fe_start_sortie: flownDate,
    fe_stop_sortie: flownDate,
})
